export const LOCAL_DRAFT_SELECTION_PREFIX = 'local:';

export interface PartitionedSelection {
  serverIds: string[];
  localSessionIds: string[];
}

export const toLocalDraftSelectionId = (sessionId: string): string =>
  `${LOCAL_DRAFT_SELECTION_PREFIX}${sessionId}`;

export const isLocalDraftSelectionId = (id: string): boolean =>
  id.startsWith(LOCAL_DRAFT_SELECTION_PREFIX);

export const fromLocalDraftSelectionId = (id: string): string =>
  id.slice(LOCAL_DRAFT_SELECTION_PREFIX.length);

export const withoutLocalDraftIds = (ids: Iterable<string>): string[] =>
  Array.from(ids).filter((id) => !isLocalDraftSelectionId(id));

export const partitionSelection = (
  ids: Iterable<string>,
): PartitionedSelection => {
  const partition: PartitionedSelection = {
    serverIds: [],
    localSessionIds: [],
  };
  for (const id of ids) {
    if (isLocalDraftSelectionId(id)) {
      partition.localSessionIds.push(fromLocalDraftSelectionId(id));
    } else {
      partition.serverIds.push(id);
    }
  }
  return partition;
};
